import { ThemeSelectors } from "@at/design-system-foundation";
import { BREAKPOINTS } from "@at/window-utils";
import styled from "styled-components";

export const GalleryModalSliderImage = styled.div`
    display: block;
    box-sizing: content-box;
    height: 0px;
    overflow: hidden;
    padding-top: calc(100vh - 60px);
    @media (min-width: 1150px) {
      padding-top: calc(100vh - 95px);
    }

    > div {
        position: absolute;
        inset: 0px;
        width: auto;
        max-width: 100%;
        height: auto;
        max-height: 100%;
        margin: auto;
        aspect-ratio: 4 / 3;
    }
}
`;

export const GallerySliderWrapper = styled.div`
  margin: 0 auto;
  width: 100%;

  @media (min-width: ${BREAKPOINTS.MEDIUM}px) {
    padding: 0 80px;
  }
`;

export const GalleryDescription = styled.div`
  position: absolute;
  bottom: ${({ theme }) => ThemeSelectors.getGroupFiveSpacing(theme)};
  right: ${({ theme }) => ThemeSelectors.getGroupFiveSpacing(theme)};
  background-color: rgba(47, 47, 47, 0.8);
  padding: ${({ theme }) => ThemeSelectors.getGroupThreeSpacing(theme)}
    ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
  min-width: 170px;
  border-radius: ${({ theme }) => ThemeSelectors.getGroupOneSpacing(theme)};
  color: ${({ theme }) => ThemeSelectors.getWhite(theme)};
  text-align: right;

  p {
    padding: 0 0 ${({ theme }) => ThemeSelectors.getGroupOneSpacing(theme)};
    margin: 0;
    &:first-child {
      margin-bottom: ${({ theme }) =>
        ThemeSelectors.getGroupThreeSpacing(theme)};
    }
    &:last-child {
      margin: 0;
      padding: 0;
    }
  }

  @media (min-width: 1500px) {
    bottom: 40px;
    right: 60px;
  }
`;
